/**
 * Module dependencies.
 */

import { Container } from 'src/components/core/layout/container';
import { Image } from 'src/components/core/image';
import { Lead, Title } from 'src/components/layout/homepage/styles';
import { media } from 'src/styles/utils/media';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  imageAlt: string;
  imageUrl: string;
  lead: string;
  title: string;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.section`
  align-items: center;
  background-color: var(--color-gray700);
  color: var(--color-white);
  display: flex;
  overflow-x: clip;
  padding: 18vmax 0 8vmax;
  position: relative;
`;

/**
 * `ImageOverlay` styled component.
 */

const ImageOverlay = styled.div`
  background: var(--gradient-header-overlay);
  inset: 0;
  position: absolute;
`;

/**
 * `Grid` styled component.
 */

const Grid = styled.div`
  ${media.min.sm`
    display: grid;
    grid-template-areas: 'title .' 'lead .';
    grid-template-columns: 8fr 2fr;
  `}

  ${media.min.sm`
    grid-template-columns: 6fr 4fr;
  `}
`;

/**
 * `Header` component.
 */

export function Header({ imageAlt, imageUrl, lead, title }: Props) {
  return (
    <Wrapper>
      <Image
        alt={imageAlt}
        fill
        priority
        src={imageUrl}
      />

      <ImageOverlay />

      <Container>
        <Grid>
          <Title
            as={'h2'}
            data-scroll={'fade-in-up'}
            style={{ gridArea: 'title' }}
          >
            {lead}
          </Title>

          <Lead
            as={'h1'}
            data-scroll={'fade-in-up'}
            data-scroll-animation-delay={100}
            style={{ gridArea: 'lead' }}
          >
            {title}
          </Lead>
        </Grid>
      </Container>
    </Wrapper>
  );
}
